import React from "react";
import { CONTACT_EMAIL, COUPLE_NAME, WEDDING_DATE_DISPLAY, WEDDING_LOCATION } from "../config";

export default function Footer() {
  return (
    <footer className="bg-gray-800 text-gray-200 py-6">
      <div className="max-w-6xl mx-auto px-4 flex flex-col md:flex-row justify-between items-center">
        <div className="text-center md:text-left">
          <div className="font-display text-xl font-bold">{COUPLE_NAME}</div>
          <div className="text-sm">{WEDDING_DATE_DISPLAY} – {WEDDING_LOCATION}</div>
        </div>
        <div className="mt-4 md:mt-0 text-center">
          <a href={`mailto:${CONTACT_EMAIL}`} className="underline">{CONTACT_EMAIL}</a>
          <div className="text-xs mt-2">© {new Date().getFullYear()} — All rights reserved</div>
        </div>
      </div>
    </footer>
  );
}
